import { useNavigate } from 'react-router-dom';
import useService from '../../injector/hooks/useService';
import { ActivationStatusService } from '../../core/services/activation-status.service';

export function useActivationGuard() {
  const activationStatusService = useService(ActivationStatusService);
  const navigate = useNavigate();

  const executeActivationGuard = () => {
    if (activationStatusService.shouldShowActivation()) {
      return true;
    }

    navigate('/');

    return false;
  };

  return {
    executeActivationGuard
  };
}
